export default __webpack_public_path__ + "images/5e3551fa9325590682e2ed5e4a00617e-literaryarts.webp";